import moment from 'moment'
import {
  KPIDemandsAPI,
  KpiProperties,
} from 'utils/__interfaces/SuperAdministration/Kpis/KPI'

const formatKPIDemandesForExport = (
  monthExportLabels: string[],
  data: KPIDemandsAPI[]
) => {
  const typeRejeuLabels = ['1ère tentative', 'Rejeu 1', 'Rejeu 2', 'Rejeu 3']
  const result: KpiProperties[] = []

  const defaultData = { succesWeb: 0, succesMob: 0, echecWeb: 0, echecMob: 0 }

  // Remplissage des données
  data.forEach((entry) => {
    const {
      categoryLabel,
      motifLabel,
      anneeMois,
      typeRejeu,
      succes,
      echec,
      canal,
    } = entry

    // Trouver l'index du mois dans monthExportLabels
    const monthIndex = monthExportLabels.indexOf(
      moment(anneeMois, 'YYYY_MM').format('MM-YYYY')
    )

    if (monthIndex !== -1) {
      // Chercher si l'entrée existe déjà
      const existingEntry = result.find(
        (item) =>
          item.category === categoryLabel &&
          item.motif === motifLabel &&
          item.typeRejeu === typeRejeuLabels[typeRejeu]
      )

      const isMobile = canal === 'mobile'

      // Si l'entrée existe, mettre à jour les données
      if (existingEntry) {
        const current = existingEntry.data[monthIndex]
        existingEntry.data[monthIndex] = {
          ...current,
          ...(isMobile
            ? { succesMob: succes, echecMob: echec }
            : { succesWeb: succes, echecWeb: echec }),
        }
      } else {
        // Sinon, créer une nouvelle entrée
        const newEntry: KpiProperties = {
          category: categoryLabel,
          motif: motifLabel,
          typeRejeu: typeRejeuLabels[typeRejeu],
          data: Array.from({ length: 14 }, () => ({ ...defaultData })),
        }

        // Remplir les données pour le mois spécifique
        newEntry.data[monthIndex] = {
          ...defaultData,
          ...(isMobile
            ? { succesMob: succes, echecMob: echec }
            : { succesWeb: succes, echecWeb: echec }),
        }

        result.push(newEntry)
      }
    }
  })

  // Trier le tableau par 'category', puis par 'motif', puis par 'typeRejeu'
  result.sort((a, b) => {
    const categoryComparison = a.category.localeCompare(b.category)
    if (categoryComparison !== 0) return categoryComparison

    const motifComparison = a.motif.localeCompare(b.motif)
    if (motifComparison !== 0) return motifComparison

    return (
      typeRejeuLabels.indexOf(a.typeRejeu) -
      typeRejeuLabels.indexOf(b.typeRejeu)
    )
  })

  return result
}

export default formatKPIDemandesForExport
